import React from 'react';
import { Col, Row } from 'react-bootstrap';

const AuthSubmit = ({ label, disabled }) => (
  <Row className="g-0">
    <Col xs={12} sm={12} md={12} lg={12}>
      <button id="submit-button" type="submit" className="auth-submit" disabled={disabled}>
        {label}
      </button>
    </Col>
  </Row>
);

export default AuthSubmit;
